/**
 * Dropcaps
 * --------
 */

if($('.has-dropcap').length) {

    let dropcapContainers = $('.has-dropcap');

    dropcapContainers.each(function () {

        let firstParagraph = $(this).find('p').first(),
            firstCharacter = firstParagraph.html().charAt(0).toLowerCase();

        if(firstCharacter.length === 1 && firstCharacter.match(/[a-z]/i)) {
            firstParagraph.html('<span class="dropcap-letter dropcap-letter-' + firstCharacter + '"></span>' + firstParagraph.html().slice(1));
        }

    });

}